import { eventChannel, END, EventChannel } from 'redux-saga';
import { webSocketService } from 'services/WebSocketService';
import { chatWebSocketService } from 'services/ChatWebSocketService';
import { ErrorNotifications } from 'types';

export function errorWebSocketChannel(args: ErrorNotifications[]): EventChannel<any> {
  return eventChannel((emitter) => {
    const removeListener = webSocketService.onErrorMessage((notification) => {
      emitter(notification);
    }, args[0]);

    return () => {
      removeListener();
      emitter(END);
    };
  });
}

export function errorChatWebSocketChannel(args: ErrorNotifications[]): EventChannel<any> {
  return eventChannel((emitter) => {
    const removeListener = chatWebSocketService.onErrorMessage((notification) => {
      emitter(notification);
    }, args[0]);

    return () => {
      removeListener();
      emitter(END);
    };
  });
}
